import { SxStyles } from 'types';

export const fakeInputNarrowPaddings: SxStyles = {
  paddingBlock: '3px',
  paddingLeft: '3px',
};
